import SortableTableHead from 'Components/TableBase/SortableTableHead';
import { StyledTable } from 'Components/TableBase/Table';
import React, { FC } from 'react';
import { IQuestionnaire } from 'FeatureModules/Questionnaire/types/questionnaire.types';
import QuestionnaireTableBody from './QuestionnaireTableBody';
import {
  EQuestionnaireHeaderColumnEnum,
  getQuestionnaireHeaderColumns,
} from './questionnaireHeaderColumns';

interface IQuestionnaireTableProps {
  questionnaires: IQuestionnaire[];
  hideHeader?: boolean;
  columns: EQuestionnaireHeaderColumnEnum[];
  onSelect: (questionnaire: IQuestionnaire, lang?: string, page?: number) => void;
  onEdit?: (questionnaire: IQuestionnaire) => void;
  onDelete?: (questionnaire: IQuestionnaire) => void;
}

const QuestionnaireTable: FC<IQuestionnaireTableProps> = ({
  questionnaires,
  hideHeader = false,
  columns,
  onSelect,
  onEdit,
  onDelete,
}) => {
  const headerColumns = getQuestionnaireHeaderColumns(columns);

  return (
    <>
      <StyledTable data-testid="questionnaires-table">
        {!hideHeader && <SortableTableHead headerColumns={headerColumns} />}
        <QuestionnaireTableBody
          questionnaires={questionnaires}
          onSelect={onSelect}
          onEdit={onEdit}
          onDelete={onDelete}
          headerColumns={headerColumns}
        />
      </StyledTable>
    </>
  );
};

export default QuestionnaireTable;
